import { render, staticRenderFns } from "./MedicalRequests.vue?vue&type=template&id=1eb46f0c&"
import script from "./MedicalRequests.vue?vue&type=script&lang=js&"
export * from "./MedicalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports